import { produce } from "immer";
import { z } from "zod";
import { doubleEncode, makeGetRequest } from "../../utils";

type GetSharingRecordingDetailsOptions = {
	sessionId: string;
	type?: "past" | "live";
	page_size?: number;
	next_page_token?: string;
};

const UserDetail = z.object({
	content: z.string(),
	start_time: z.string(),
	end_time: z.string(),
});

const User = z.object({
	id: z.string(),
	name: z.string(),
	details: z.array(UserDetail),
});

const ResponseSchema = z
	.object({
		page_size: z.number(),
		next_page_token: z.string(),
		users: z.array(User),
	})
	.deepPartial();

type Response = z.infer<typeof ResponseSchema>;

const getSharingRecordingDetails = async (
	token: string,
	options: GetSharingRecordingDetailsOptions,
): Promise<Response> => {
	const res = await makeGetRequest({
		token,
		pathList: [
			"v2",
			"videosdk",
			"sessions",
			doubleEncode(options.sessionId),
			"users",
			"sharing",
		],
		options: produce(options, (draft) => {
			if (!draft.type) {
				draft.type = "live";
			}
		}),
	});
	const parsed = ResponseSchema.parse(res);
	return parsed;
};

export const curriedGetSharingRecordingDetails = (token: string) => (
	options: GetSharingRecordingDetailsOptions,
) => getSharingRecordingDetails(token, options);